import { render, staticRenderFns } from "./MoleculeEditionAcademyUsersProfileSubMenu.vue?vue&type=template&id=2282edf2&"
import script from "./MoleculeEditionAcademyUsersProfileSubMenu.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionAcademyUsersProfileSubMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports